import { render, staticRenderFns } from "./AddRegistration.vue?vue&type=template&id=6d103298"
import script from "./AddRegistration.vue?vue&type=script&lang=js"
export * from "./AddRegistration.vue?vue&type=script&lang=js"
import style0 from "./AddRegistration.vue?vue&type=style&index=0&id=6d103298&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports